import { Container, Paper, Stack, Typography } from '@mui/material'
import type React from 'react'
import { useLocation } from 'react-router-dom'
import Logo from 'src/assets/images/logo_report_blue_katakana.svg?react'

const MaintenanceContainer: React.FC = () => {
  const location = useLocation()

  const params = location.search.replace('?params=', '') || ''

  const safeDecode = (v: string) => {
    try {
      return decodeURIComponent(v)
    } catch {
      return v
    }
  }
  const [msg, time] = params.split(',').map(safeDecode)

  return (
    <Stack height="100vh" alignItems="center" justifyContent="center">
      <Container maxWidth="md">
        <Paper elevation={1} sx={{ p: 6 }}>
          <Stack spacing={4} alignItems="center">
            <Logo width={287} height={40} />
            <Typography variant="h4">システムメンテナンスのお知らせ</Typography>
            {msg && (
              <Typography variant="body2" sx={{ whiteSpace: 'pre-line' }}>
                {msg}
              </Typography>
            )}
            <Stack gap={1} alignItems="center">
              <Typography variant="h6">[メンテナンス時間]</Typography>
              {time && (
                <Typography variant="body1" fontWeight="bold">
                  {time}
                </Typography>
              )}
            </Stack>
            <Typography variant="body2">
              なお、上記時間は前後する可能性がございます。
              <br />
              ご利用の皆様には、ご不便をおかけして大変申し訳ありませんが、
              <br />
              ご理解いただきますようお願い申し上げます。
            </Typography>
          </Stack>
        </Paper>
      </Container>
    </Stack>
  )
}

export default MaintenanceContainer
